import React, { useState, useEffect } from "react";
import moment from "moment";
import InfiniteScroll from "react-infinite-scroll-component";
import LearningPathCard from "../../components/cards/LearningPathCard";
import { useListTracksQuery } from "../../services/users/learningTrack";
import LoadingIndicator from "../../components/LoadingIndicator";
import EmptyState from "../../components/EmptyState";
import { useTranslation } from "react-i18next";
import { LearningPathsStrokeIcon } from "../../components/icons/Icons";
import Icon from "../../components/icons/Icon";

export default function Learningpaths() {
  const [allLearningTracks, setAllLearningTracks] = useState([]);
  const [page, setPage] = useState(1);
  const { t } = useTranslation(["common", "learningPaths"]);
  const { data: learningTracks, isLoading: isLearningTracksLoading } =
    useListTracksQuery({ page });

  useEffect(() => {
    if (learningTracks?.data?.length) {
      if (learningTracks?.pagination?.current == 1) {
        setAllLearningTracks(learningTracks?.data);
      } else {
        setAllLearningTracks((prev) => {
          return [...prev, ...learningTracks?.data];
        });
      }
    } else if (learningTracks && learningTracks?.pagination?.current == 1) {
      setAllLearningTracks([]);
    }
  }, [learningTracks]);

  if (isLearningTracksLoading && page === 1) return <LoadingIndicator />;

  return (
    <div className="container-fluid employee-learning-tracks">
      <div className="row justify-content-center p-4">
        <div className="col-lg-10 col-md-12">
          <header className="employee-learning-tracks__header mb-4">
            <h1 className="employee-learning-tracks__title mb-1 font_24 font-extrabold">
              {t("learningPathsTitle")}
            </h1>
            <p className="employee-learning-tracks__subtitle mb-0 font_16 font-color-grey">
              {t("recentlySubscribedLearningPaths", {
                count: learningTracks?.pagination?.count ?? 0,
              })}
            </p>
          </header>

          <div className="employee-learning-tracks__body">
            {!isLearningTracksLoading && allLearningTracks.length === 0 ? (
              <EmptyState
                iconComponent={
                  <Icon
                    icon={<LearningPathsStrokeIcon />}
                    hasStroke
                    iconName="learning-path-stroke"
                    iconColor="#bbbabf"
                    iconSize={38}
                    viewBox="0 0 23 19"
                  />
                }
                title={t("emptyStates.learningPaths")}
                emptyStateText={t("learningPaths:noTracksFound")}
              />
            ) : (
              <InfiniteScroll
                className="employee-learning-tracks__list"
                dataLength={allLearningTracks.length}
                next={() => setPage(learningTracks?.pagination?.next)}
                hasMore={!!learningTracks?.pagination?.next}
                loader={
                  <h4 className="employee-learning-tracks__loader">
                    {t("Loading")}
                  </h4>
                }
                endMessage={
                  <p className="employee-learning-tracks__end-message font-color-grey">
                    {t("successfulLearningPathDisplay")}
                  </p>
                }
                style={{ overflow: "unset" }}
              >
                {allLearningTracks.map((learningTrack) => {
                  const ProgressBarPercentage = `${learningTrack?.enrollment?.progress}%`;
                  const completeDate = moment(
                    new Date(learningTrack?.enrollment?.complete_by),
                  );
                  const oneDay = 24 * 60 * 60 * 1000;
                  const remainingDays = Math.round(
                    (completeDate - new Date()) / oneDay,
                  );

                  return (
                    <div
                      key={learningTrack?.id}
                      className="employee-learning-tracks__item"
                    >
                      <LearningPathCard
                        id={learningTrack?.id}
                        title={learningTrack?.title}
                        image={learningTrack?.image_url}
                        ProgressBarPercentage={ProgressBarPercentage}
                        ProgressBarWidth="100%"
                        coursesCounts={learningTrack?.courses_count}
                        completedCoursesCount={
                          learningTrack?.enrollment?.completed_courses_count
                        }
                        completeBy={completeDate.format("DD / MM / YYYY")}
                        remainingDays={remainingDays}
                        learningTrackPageUrl={
                          learningTrack?.archived
                            ? "#"
                            : learningTrack?.enrollment?.progress === 100
                              ? null
                              : `/employee/learning_paths/${learningTrack?.id}`
                        }
                        buttonText={
                          learningTrack?.archived
                            ? t("learningPaths:deletedTrack")
                            : learningTrack?.enrollment?.progress === 100
                              ? null
                              : learningTrack?.enrollment?.progress
                                ? t("learningPaths:continueLearning")
                                : t("learningPaths:startLearning")
                        }
                        buttonType={
                          learningTrack?.enrollment?.progress === 100
                            ? "completed"
                            : learningTrack?.enrollment?.progress
                              ? "inprogress"
                              : "start"
                        }
                        buttonIcon={
                          !learningTrack?.archived &&
                          learningTrack?.enrollment?.progress !== 100
                        }
                        isArchived={learningTrack?.archived}
                      />
                    </div>
                  );
                })}
              </InfiniteScroll>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
